'use client';

import { ReactNode } from 'react';

import PartnerhubHeader from '@/containers/Partnerhub/PartnerhubHeader/PartnerhubHeader';

import { PropsWithLang } from '@/types/types';
import '@/styles/_styleph.scss';
import { useContentfulLiveUpdates } from '@contentful/live-preview/react';
import { TEntriesResponse } from '@/features/contentful/types/types';
import { TypeMegaMenuComponentWithoutUnresolvableLinksResponse } from '@/features/contentful/_generated';
import PartnerhubSimpleHeader from '@/containers/Partnerhub/PartnerhubHeader/PartnerhubSimpleHeader';
import AppFooter from '@/containers/AppFooter/AppFooter';

type LayoutProps = {
    children: ReactNode;
    megaMenu?: TEntriesResponse<TypeMegaMenuComponentWithoutUnresolvableLinksResponse[]>;
    footerData?: TypeMegaMenuComponentWithoutUnresolvableLinksResponse;
} & PropsWithLang;

export default function PartnerhubLayout({
    children,
    lang,
    megaMenu,
    footerData,
}: Readonly<LayoutProps>) {
    const liveMegaMenu = useContentfulLiveUpdates(megaMenu);
    const liveFooterMenu = useContentfulLiveUpdates(footerData);

    return (
        <div className="partner-hub tw-flex tw-flex-col tw-grow">
            {megaMenu ? (
                <PartnerhubHeader lang={lang} megaMenu={liveMegaMenu} />
            ) : (
                <PartnerhubSimpleHeader lang={lang} />
            )}
            {children}
            <AppFooter lang={lang} footerData={liveFooterMenu} />
        </div>
    );
}
